import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RoutePage from '../components/RoutePage';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const RouteSlideShow = ({
    urlEndpoint,
    urlMethod,
    urlData,
    setPageHeader,
    pageName
}) => {
    // if (setPageHeader) {
    //     setPageHeader(pageName);
    // }
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [settings, setSettings] = useState({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 5000,
        cssEase: "linear",
        arrows: false
    });

    useEffect(() => {
        liracrypt.get(urlEndpoint, urlData)
            .then(response => {
                if (setPageHeader) {
                    setPageHeader(response.data.config?.pageTitle || 'Route SlideShow XASDF');
                }
                setData(response.data.data);
                setSettings({
                    ...settings,
                    autoplaySpeed: response.data.data.interval
                });
                setLoading(false);
            }
            ).catch(err => {
                console.log(err);
            }
            )
    }, []);

    return loading ? <Spin indicator={antIcon} /> : (
        <div>
            <Slider {...settings}>
                {
                    data?.routes?.map((item, index) => (
                        <div key={index}>
                            <RoutePage route={item.route} params={item.params} />
                        </div>
                    ))
                }
            </Slider>
        </div>
    );
}

export default RouteSlideShow;